import { render, staticRenderFns } from "./chatView.vue?vue&type=template&id=712cd6ba&scoped=true"
import script from "./chatView.vue?vue&type=script&lang=js"
export * from "./chatView.vue?vue&type=script&lang=js"
import style0 from "./chatView.vue?vue&type=style&index=0&id=712cd6ba&prod&lang=css"
import style1 from "./chatView.vue?vue&type=style&index=1&id=712cd6ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712cd6ba",
  null
  
)

export default component.exports